<div class="content-block">

  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Magazzino</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Magazzino</li>
            <li class="breadcrumb-item active">Importazione dati distributore</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->


  <section class="col-lg-12 ">

    <div class="card primary">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
          <span>Importazione dati distributore</span>
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-sm-12 col-xs-12 mb-6">
            <div class="dx-field">
              <div class="dx-field-label">Distributore </div>
              <div class="dx-field-value">

                <dx-lookup
                  [displayExpr]="getDisplayExprDistributore"
                  valueExpr="id"
                  [dataSource]="listDistributori"
                  [searchEnabled]="true"
                  [(value)]="idDistributoreSelected"
                  >

                </dx-lookup>

              </div>
            </div>
          </div>
          @if (idDistributoreSelected > 0) {
            <div class="col-xl-6 col-lg-6 col-sm-12 col-xs-12 mb-6">
              <div class="row dx-field">
                <div class="dx-field-label col-2">FILE DISTRIBUTORE:</div>
                <div class="dx-field-value col-4">
                  <dx-file-uploader #fileUploader [multiple]="false" accept=".csv, .xlsx, .xls" [(value)]="fileValue"
                    uploadMode="useForm">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="Selezionare il file">
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-file-uploader>
                </div>
              </div>
              <div class="row dx-field" >
                <div class="dx-field-label col-md-2 col-lg-4"></div>
                <div class="col-6">
                  @if (fileUploader.value?.length > 0) {
                    <div>
                      <dx-button icon="fa fa-upload" text="Carica" class="pulsante-azione"
                        (onClick)="allegaFile(fileUploader.value)">
                      </dx-button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>

      </div><!-- /.card-body -->
    </div>
    <!-- /.card -->

  </section>

</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

<app-popup-import-distributori-result [popupVisibleObs]="popupResultVisibleObs" [importResult]="importResult" [popupTitle]="resultTitle"></app-popup-import-distributori-result>




